import React, { useState } from "react";
import "./ChurchHistoryTimeline.css";

const ChurchHistoryTimeline = ({ text, language }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Parse the text into timeline sections
  const parseTimelineSections = () => {
    let sections = [];

    // Split the text by double newlines to get the three main sections
    const textParts = text
      .split("\n\n")
      .filter((part) => part.trim().length > 0);

    if (language === "amharic" || language === "am") {
      // Amharic sections
      const amharicSections = [
        {
          title: "ቅድመ ቤተ ክርስቲያን",
          titleEnglish: "Pre Church",
          year: "2001",
          content: textParts[0] || "",
        },
        {
          title: "የቤተክርስቲያኗ መቋቋም",
          titleEnglish: "Establishment of the Church",
          year: "2018",
          content: textParts[1] || "",
        },
        {
          title: "የወድፊት እቅዶች",
          titleEnglish: "Future Plan",
          year: "2023",
          content: textParts[2] || "",
        },
      ];
      sections = amharicSections;
    } else {
      // English sections
      const englishSections = [
        {
          title: "Pre church",
          titleEnglish: "Pre Church",
          year: "2001",
          content: textParts[0] || "",
        },
        {
          title: "Establishment of the church",
          titleEnglish: "Establishment of the Church",
          year: "2018",
          content: textParts[1] || "",
        },
        {
          title: "Future plan",
          titleEnglish: "Future Plan",
          year: "2023",
          content: textParts[2] || "",
        },
      ];
      sections = englishSections;
    }

    return sections.filter((s) => s.content.trim().length > 0);
  };

  const sections = parseTimelineSections();

  const handleSectionClick = (index) => {
    setActiveIndex(index);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % sections.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + sections.length) % sections.length);
  };

  return (
    <div className="church-history-timeline">
      <div className="timeline-container">
        <div className="timeline-track">
          {sections.map((section, index) => (
            <div
              key={index}
              className={`timeline-node ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => handleSectionClick(index)}
            >
              <div className="node-year">{section.year}</div>
              <div className="node-dot"></div>
              <div className="node-label">{section.title}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="timeline-content">
        <div className={`content-wrapper ${activeIndex}`}>
          {sections.map((section, index) => (
            <div
              key={index}
              className={`section-content ${
                activeIndex === index ? "active" : ""
              }`}
            >
              <div className="section-header">
                <h3 className="section-title">{section.title}</h3>
                <span className="section-year">{section.year}</span>
              </div>
              <p className="section-text">{section.content.trim()}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="timeline-controls">
        <button
          className="control-btn prev-btn"
          onClick={handlePrev}
          title="Previous"
        >
          ← {language === "amharic" || language === "am" ? "ወደኋላ" : "Prev"}
        </button>
        <div className="progress-indicators">
          {sections.map((_, index) => (
            <span
              key={index}
              className={`indicator ${activeIndex === index ? "active" : ""}`}
              onClick={() => handleSectionClick(index)}
            ></span>
          ))}
        </div>
        <button
          className="control-btn next-btn"
          onClick={handleNext}
          title="Next"
        >
          {language === "amharic" || language === "am" ? "ወደፊት" : "Next"} →
        </button>
      </div>

      <div className="timeline-info">
        <p className="info-text">
          {activeIndex + 1} of {sections.length}
        </p>
      </div>
    </div>
  );
};

export default ChurchHistoryTimeline;
